module.exports = __webpack_public_path__ + "img/box.131c7931.svg";